import { isCurrency, type Currency } from '@talkofthetown/shared';
import { useState } from 'react';
import { config } from '../config';

const KEY = 'tott.currency';

/** The currencies switched on for this site (INR at least). */
export const currencies: Currency[] = (() => {
  const on = config.currencies.filter(isCurrency);
  return on.length > 0 ? on : ['INR'];
})();

/** Rupees for readers in India (by their clock's time zone), dollars elsewhere, when offered. */
function defaultCurrency(): Currency {
  const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const india = zone === 'Asia/Kolkata' || zone === 'Asia/Calcutta';
  const preferred: Currency = india ? 'INR' : 'USD';
  return currencies.includes(preferred) ? preferred : currencies[0]!;
}

function saved(): Currency | null {
  try {
    const c = localStorage.getItem(KEY);
    return isCurrency(c) && currencies.includes(c) ? c : null;
  } catch {
    return null;
  }
}

/** The currency prices show in, which the reader can switch (remembered in this browser). */
export function useCurrency(): [Currency, (c: Currency) => void] {
  const [currency, setCurrency] = useState<Currency>(() => saved() ?? defaultCurrency());
  const choose = (c: Currency) => {
    setCurrency(c);
    try {
      localStorage.setItem(KEY, c);
    } catch {
      /* private mode: just for now */
    }
  };
  return [currency, choose];
}
